// components/forms/OnsetInfoForm.js
import React from 'react';
import { Clock } from 'lucide-react';

function OnsetInfoForm({ data, setData }) {
    const handleChange = (field, value) => {
        setData({
            ...data,
            [field]: value
        });
    };

    return (
        <div className="space-y-4">
            <h2 className="text-xl font-bold mb-4">发病情况</h2>

            <div className="grid grid-cols-1 gap-4">
                <div className="flex items-center bg-yellow-50 p-3 rounded-lg border border-yellow-200">
                    <Clock className="text-yellow-500 mr-2" />
                    <span className="text-sm text-yellow-700">提示：精确记录发病时间对于脑卒中治疗至关重要！</span>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">症状开始的确切时间</label>
                    <input
                        type="datetime-local"
                        className="w-full p-2 border rounded"
                        value={data.onsetTime}
                        onChange={(e) => handleChange('onsetTime', e.target.value)}
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">发病时的状态</label>
                    <select
                        className="w-full p-2 border rounded"
                        value={data.onsetState}
                        onChange={(e) => handleChange('onsetState', e.target.value)}
                    >
                        <option value="">请选择</option>
                        <option value="患者在清醒状态下发病">清醒状态</option>
                        <option value="患者在睡眠中发病">睡眠中</option>
                        <option value="患者在活动中发病">活动中</option>
                        <option value="患者在进食时发病">进食时</option>
                        <option value="其他状态下发病">其他</option>
                    </select>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">有无目击者</label>
                    <select
                        className="w-full p-2 border rounded"
                        value={data.witnesses}
                        onChange={(e) => handleChange('witnesses', e.target.value)}
                    >
                        <option value="">请选择</option>
                        <option value="有目击者">有</option>
                        <option value="无目击者">无</option>
                    </select>
                </div>
            </div>
        </div>
    );
}

export default OnsetInfoForm;